import React, { useEffect, useRef, useState } from 'react';
import SearchBox from '../Common/SearchBox/SearchBox';
import Listing from '../Common/Listing/Listing';
import { useDispatch } from 'react-redux';
import _ from 'lodash'

/*
 {
                "id": "user",
                "name": "User",
                "type": "asyncSelect",
                "placeholder": "Search for a user",
                "label": "User",
                "size": "6"
            }
*/

const SearchBoxWithListing = (props) => {
    const { fetchForm, listApi, actionsHandling, searchBoxJson = {}, listingData = {}, searchBoxKey = '', listFormKey = '', updatedSearchBoxValues = {}, componentsInMiddle, disableFetchingForm = false } = props;
    const { headers = [], data: listData = [], meta = {} } = listingData;
    const dispatch = useDispatch();
    const [fetchingSearchForm, setFetchingSearchForm] = useState(_.isEmpty(searchBoxJson));
    const [fetchingList, setFetchingList] = useState(false);
    const [lastSearchPayload, setLastSearchPayload] = useState({});
    const requestControllerRef = useRef(null);

    useEffect(() => {
        if (_.isEmpty(searchBoxJson) && !disableFetchingForm)
            dispatch(fetchForm(searchBoxKey, listFormKey));
    }, []);

    useEffect(() => {
        // console.log("SearchBoxWithListing-useEffect[searchBoxJson]");
        if (!_.isEmpty(searchBoxJson) && fetchingSearchForm) {
            setFetchingSearchForm(false);
        }
    }, [searchBoxJson])

    useEffect(() => {
        return () => {
            if (requestControllerRef.current) {
                requestControllerRef.current.abort();
                requestControllerRef.current = null;
            }
        };
    }, []);

    const executeListApi = async (payload) => {
        if (requestControllerRef.current) {
            requestControllerRef.current.abort();
        }
        const controller = new AbortController();
        requestControllerRef.current = controller;
        setFetchingList(true);
        try {
            await Promise.resolve(listApi(payload, { signal: controller.signal }));
        } finally {
            // console.log("Setting false finally");
            setFetchingList(false);
            if (requestControllerRef.current === controller) {
                requestControllerRef.current = null;
            }
        }
    };

    const handleSearch = async (data) => {
        setFetchingList(true);
        setLastSearchPayload(data);
        await executeListApi(data);
    };

    const handleRefresh = async () => {
        await executeListApi(lastSearchPayload);
    }

    const handleCancel = () => {
        if (requestControllerRef.current) {
            requestControllerRef.current.abort();
            requestControllerRef.current = null;
        }
        // console.log("Setting false");
        setFetchingList(false);
    }

    // console.log("fetchingList", fetchingList);

    return (
        <div>
            <SearchBox
                searchBoxJson={searchBoxJson}
                onSearch={handleSearch}
                fetchingForm={fetchingSearchForm}
                updatedValues={updatedSearchBoxValues}
                fetchingList={fetchingList}
                onCancel={handleCancel}
            />
            {componentsInMiddle}
            {headers.length > 0 ?
                <Listing
                    headers={headers}
                    data={listData}
                    onSearch={handleRefresh}
                    meta={meta}
                    actionsHandling={actionsHandling}
                    fetchingList={fetchingList}
                /> : ''}
        </div>

    )
}

export default SearchBoxWithListing;
